import { Cells } from 'common/types/scalarSpreadsheet';
import { ICell } from 'models/interfaces/spreadsheet-types/core-types';
import { BacksolveApproachAttributes } from 'pages/ValuationsAllocation/types';
import { parseDatabaseValue } from 'utilities';
import { ReverseParserProps } from './type';

const reverseParse = (
  security: any,
  cell: ICell,
  cells: Cells,
  fieldAttributes: BacksolveApproachAttributes,
  allowEmptyValues: boolean
) => {
  const { key } = cell;
  const defaultValue = cell.defaultValue ?? null;
  const type = cell.dbType ?? null;
  const format = cell.format ?? null;
  const value = cells[key as keyof typeof cells] ? cells[key as keyof typeof cells].value : defaultValue;
  const { gridType } = cell;
  const fieldAttributesDecimalPlaces = fieldAttributes[cell.alias as keyof BacksolveApproachAttributes]?.decimal_places;
  const decimalPlaces = Number(fieldAttributesDecimalPlaces ?? cell?.dbDecimalPlaces);

  const calcValue = parseDatabaseValue({
    type,
    value,
    format,
    allowEmptyValues,
    gridType,
    decimalPlaces,
  });
  // eslint-disable-next-line no-param-reassign
  security[cell.alias] = calcValue;
};

const reverseParser = ({ cells, tableData, fieldAttributes, allowEmptyValues }: ReverseParserProps) => {
  const alphabet = ['A', 'B', 'C', 'D'];
  tableData.securitiesBasket.basket.forEach((security: any, index: number) => {
    alphabet.forEach(columnLegend => {
      const cell = cells[`${columnLegend}${index + 2}`];
      reverseParse(security, cell, cells, fieldAttributes, allowEmptyValues);
    });
  });
};

export default reverseParser;
